export default [
    "24 24",
    '<path d="M8.52693 3C9.47384 2.07211 10.7707 1.5 12.2012 1.5C15.1007 1.5 17.4512 3.8505 17.4512 6.75C17.4512 8.1805 16.879 9.47738 15.9511 10.4243M12.9512 11.25C12.9512 14.1495 10.6007 16.5 7.70117 16.5C4.80168 16.5 2.45117 14.1495 2.45117 11.25C2.45117 8.3505 4.80168 6 7.70117 6C10.6007 6 12.9512 8.3505 12.9512 11.25Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>']

